var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',[_c('div',{style:({ height: _vm.height })},[_c('quill-editor',{ref:"editor",style:(_vm.style),attrs:{"options":_vm.options},on:{"change":function($event){return _vm.contentChange($event)}},model:{value:(_vm.value),callback:function ($$v) {_vm.value=$$v},expression:"value"}})],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }